import { Box, Button,CircularProgress,IconButton, Tooltip } from "@mui/material";
import { useSelector,useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import BlankAreaMenu from "../ContextMenu/BlankAreaMenu";
import WfgContextMenu from "../ContextMenu/WfgContextMenu";
import WftContextMenu from "../ContextMenu/WftContextMenu";
import WorkflowGroupsTree from "../Trees/WorkflowGroupsTree";
import InputIcon from "@mui/icons-material/Input";
import OutputIcon from "@mui/icons-material/Output";
import CategoryIcon from "@mui/icons-material/Category";
import { useContext, useRef, useState } from "react";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { newTemplateActions } from "../../redux/slices/newTemplateSlice";
import NtwAlert from "../ContextMenu/NewTemplateWizard/NtwContentOptions/NtwAlert";
import Typography from '@mui/material/Typography';
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { styled, alpha } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';
import InputAdornment from '@mui/material/InputAdornment';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import { CSSTransition } from 'react-transition-group';
import  LightTooltip  from "../../commonComponents/LightTooltip";
import WorkflowTemplateMenu from "../ContextMenu/WorkflowTemplateMenu";
import DocumentContextMenu from "../ContextMenu/DocumentContextMenu";
const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(1),
    width: 'auto',
  },
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  width: '100%',
  '& .MuiInputBase-input': {
    // padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    // paddingLeft: `calc(0.5em + ${theme.spacing(2)})`,
    transition: theme.transitions.create('width'),
    [theme.breakpoints.up('sm')]: {
      width: '20ch',
    },
  },
}));
export default function WorkflowGroupPanel() {
  const { t } = useTranslation();
  const parentScreen = useContext(ParentScreenCtx)
  const { leftTree } = useSelector((state) =>state.treeData[parentScreen]);
  const { loading } = useSelector((state) =>state.treeData[parentScreen].rightTree);
  const  leftTreeLoading  = useSelector((state) =>state.treeData[parentScreen].leftTree.loading);
  const templateAction = useSelector((state)=>state.treeData[parentScreen].leftTree.templateAction);
  const treeParentRef = useRef();
  const dispatch = useDispatch()
  const newTemplate = useSelector((state) => state.newTemplate);
  const [searchParam, setSearchParam] = useState('')
  const [showInput,setShowInput] = useState(false)
  const [showSearchBtn,setShowSearchBtn] = useState(true)
  const {showAlert,alertMessage,alertType} = newTemplate
  const handleAlertClose = () =>{
    dispatch(newTemplateActions.setShowAlert(false))
    dispatch(newTemplateActions.setAlertMessage(''))
  }

  return (
    <div className="flex-column height-100">
      <Box
        className="divider-bottom flex space-between align-center">
        <Button
          size="small"
          className="left-tree-tab-button"
          sx={{ cursor: "unset", pointerEvents: "none" }}
        >
          { //display proper label/icon accordin to current tab
            parentScreen === "inbound" ? 
              (<>
                <InputIcon fontSize="small" className="margin-right-4" />
                {t("LBL_IN_TEMPLATES")}
              </>) : 
            parentScreen === "outbound" ? 
              (<>
                <OutputIcon fontSize="small" className="margin-right-4 wgp-outputIcon" />
                {t("LBL_OUT_TEMPLATES")}
              </>) : 
            (<>
              <CategoryIcon fontSize="small" className="margin-right-4" />
              {t("LBL_WORKFLOWS")}
            </>)
          }
        </Button>
          <div style={{ display: "flex" }}>
            {(["inbound", "outbound", "workflow"].includes(parentScreen)) && (<div style={{ display: "flex"}}>
              <CSSTransition
                in={showInput}
                timeout={300}
                classNames="search"
                unmountOnExit
                onEnter={() => setShowSearchBtn(false)}
                onExited={() => setShowSearchBtn(true)}
              >
                <div
                  style={{
                    height: "27px",
                    border: "solid 1px #666666",
                    borderRadius: "4px",
                    margin: "2px",
                  }}>
                  <Search>
                    <StyledInputBase
                      placeholder="Search..."
                      inputProps={{ "aria-label": "search" }}
                      value={searchParam}
                      autoFocus={true}
                      startAdornment={
                        <InputAdornment position="start">
                          <ArrowBackOutlinedIcon 
                            className="material-symbols-outlined"
                            style={{ cursor: "pointer" }}
                            onClick={() =>{
                              setSearchParam('')
                              setShowInput(false)
                            }} />
                        </InputAdornment>
                      }
                      onChange={(e) => {
                        setSearchParam(e.target.value);
                      }}
                    />
                  </Search>
                </div>
              </CSSTransition>
              {showSearchBtn && (
              <LightTooltip
                title={
                  <>
                    <Typography color="inherit">
                      {t("LBL_SEARCH")}
                    </Typography>
                  </>
                }>
                <IconButton onClick={() => setShowInput(true)}>
                  <SearchOutlinedIcon
                    className="material-symbols-outlined"
                    style={{ cursor: "pointer"}}
                  />{" "}
                </IconButton>
              </LightTooltip>
            )}
            </div>)}
            <LightTooltip
              title={
                <>
                  <div
                    className="flex flex align-center"
                    style={{ gap: "5px" }}>
                    <span className="SERVER_USER template-help"></span>
                    <Typography color="inherit">
                      {t("TEMP_LOC_BOTH")}
                    </Typography>
                  </div>
                  <div className="flex align-center" style={{ gap: "5px" }}>
                    <span className="SERVER template-help"></span>
                    <Typography color="inherit">
                      {t("TEMP_LOC_SERVER")}
                    </Typography>
                  </div>
                  <div className="flex align-center" style={{ gap: "5px" }}>
                    <span className="USER_SPACE template-help"></span>
                    <Typography color="inherit">
                      {t("TEMP_LOC_USERSPACE")}
                    </Typography>
                  </div>
                </>
              }>
              <IconButton>
                <HelpOutlineIcon
                  className="material-symbols-outlined"
                  style={{ cursor: "pointer",marginLeft:'-10px' }}
                />{" "}
              </IconButton>
            </LightTooltip>
          </div>
        
      </Box>
      <Box className="height-100-tab" id={`topLeft-${parentScreen}`}>
        <div
          ref={treeParentRef}
          id={parentScreen + "-wfg-container"}
          className="height-100 overflow-auto">
          {leftTreeLoading ? (
            <div className="padding-8 height-100-tab">
              <div className="loading-overlay">
                <div className="flex-column align-center">
                  <div className="padding-left-4 padding-bottom-8">
                    {t("LOADING_IND")}
                  </div>
                  <CircularProgress color="primary" />
                </div>
              </div>
            </div>
          ) : leftTree.tree.body.translatedData.length > 0 ? (
            <WorkflowGroupsTree
              parentRef={treeParentRef}
              searchValue={searchParam}
            />
          ) : (
            <div className="panel-no-data">
              {t("FRG_NO_WKFLOS_FOUND_FOR_ACNT").slice(0, -1)}
            </div>
          )}
        </div>

        {(Object.keys(leftTree.tree.body.translatedData || []).length === 0 ||
          Object.keys(leftTree.tree.body.selectedNode || {}).length === 0) && !loading ? (
          <BlankAreaMenu targetId = {`topLeft-${parentScreen}`} />
        ) : (
          ""
        )}

        {(Object.keys(leftTree.tree.body.selectedNode || {}).length > 0 && !loading) &&
          (leftTree.tree.body.selectedNode.type === "workflowGroup" ? (<WfgContextMenu targetId = {`topLeft-${parentScreen}`} /> 
          ) : ['inboundTemplate', 'outboundTemplate'].includes(leftTree.tree.body.selectedNode.type )? (<WftContextMenu targetId = {`topLeft-${parentScreen}`} />
          ) : (leftTree.tree.body.selectedNode.type === 'workflow' ? (<WorkflowTemplateMenu targetId={`topLeft-${parentScreen}`} />) : ""
            
          ))}
        {(Object.keys(leftTree.tree.body.selectedNode || {}).length > 0 && !loading)  && (leftTree.tree.body.selectedNode.type) === "DOCUMENT" && (
          <DocumentContextMenu targetId={`topLeft-${parentScreen}`} />
        )}
      </Box>
      {showAlert && (
        <NtwAlert
          open={showAlert}
          message={alertMessage}
          type={alertType}
          onClose={handleAlertClose}></NtwAlert>
      )}
    </div>
  );
}
